import React from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import { motion } from "framer-motion";
import { FaHtml5 ,FaNodeJs } from "react-icons/fa";
import BegProjectData from './BeginerProject';
import AdvProjectData from './AdvProject';

const Project = () => {
  const data = [
    {
      label: "Advance Project",
      value: "Advance Project",
      icon: FaNodeJs,
      desc: <AdvProjectData />,
    },{
      label: "Beginer Projects",
      value: "Beginer Projects",
      icon: FaHtml5,
      desc: <BegProjectData/>,
    },
    
  ];
  return (
    <section id="project">
      <div className="min-h-[80vh] pt-20">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Tabs
            value={data[0].value}
            className="w-full flex items-center flex-col my-10"
          >
            <TabsHeader className="md:w-96 w-96 flex items-center mb-5 drop-shadow-2xl">
              {data.map(({ label, value, icon }) => (
                <Tab key={value} value={value}>
                  <div className="flex items-center gap-2">
                    {React.createElement(icon, { className: "w-5 h-5" })}
                    {label}
                  </div>
                </Tab>
              ))}
            </TabsHeader>
            <TabsBody className="flex justify-center">
              {data.map(({ value, desc }) => (
                <TabPanel key={value} value={value}>
                  {desc}
                </TabPanel>
              ))}
            </TabsBody>
          </Tabs>
        </motion.div>
      </div>
    </section>
  );
};

export default Project;
